import ReportsService from './ReportsService'

let instance

export default function ReportsServiceProvider () {
  if (!instance) {
    instance = new ReportsService()
  }

  return instance
}



// WEBPACK FOOTER //
// ./src/api/reports/ReportsServiceProvider.js